import { Rect } from '../lib/region';
import { TYPES } from '../render/constants';
import { Action } from './action';

function condition() {
  return true;
}

export const mergeFrameAction = new Action({
  name: 'MergeFrames',
  handler: mergeFrames,
  condition: condition,
});

function mergeFrames(context) {
  const selection = context.api.getSelectedNodes();
  const isEveryFrames = selection.every((n) => n.type === TYPES.frame);

  if (!isEveryFrames || selection.length < 2) {
    return;
  }

  const targetFrame = selection[0];
  const framesToMerge = selection.slice(1);
  const initialHeight = targetFrame.h;
  const rect = Rect.from(targetFrame);
  framesToMerge.forEach((n) => {
    rect.h += n.h;
  });

  context.api.updateNode(targetFrame.id, {
    h: rect.h,
  });

  let y = initialHeight;
  framesToMerge.forEach((frame) => {
    const children = context.api.getChildren(frame.id);
    children.map((node) => {
      context.api.updateNode(node.id, {
        y: y + node.y,
        parentId: targetFrame.id,
      });
    });
    y += frame.h;
  });

  // Delete the merged frames
  framesToMerge.map((frame) => frame.id).map((id) => context.api.removeNode(id));
}
